export default {
    "Overview": "Обзор",
    "Energy": "Энергия",
    "KPI": "КПЭ",
    "Notification Breakdown": "Разбивка уведомлений",
    "Notification Summary": "Сводка уведомлений",
    "Monthly Summary": "Ежемесячная сводка",
    "Plots": "Графики",
    "Time Series Plots": "Графики временных рядов",
    "Equipment Plots": "Графики оборудования",
    "Facet Plots": "Фасетные графики",
    "Scatter Plots": "Диаграммы рассеяния",
    "Fault Detection": "Обнаружение неисправностей",
    "Fault Detection (Machine Learning)": "Обнаружение неисправностей (машинное обучение)",
    "Fault Summary": "Сводка неисправностей",
    "Diagnostics": "Диагностика",
    "Cooling Load": "Холодильная нагрузка",
    "CHW Supply Temperature": "Температура подачи холодной воды (CHW)",
    "CHW Return Temperature": "Температура возврата холодной воды (CHW)",
    "Chiller Performance": "Производительность чиллера",
    "Cooling Performance": "Производительность охлаждения",
    "Working Hours": "Рабочие часы",
    "Chiller Overview": "Обзор чиллера",
    "Config": "Конфигурация",
    "Equipments": "Оборудование",
    "Facilities": "Объекты",
    "Anomaly Descriptions": "Описания аномалий",
    "Points": "Точки",
    "Parameter": "Параметр",
    "Settings": "Настройки",
    "Report": "Отчет",
    "Rules": "Правила",
    "Export Data": "Экспорт данных",
    "Custom Views": "Пользовательские представления",
    "Dates": "Даты",
    "Equipment Servicing Schedule": "График обслуживания оборудования",
    "Menu items": "Пункты меню",
    "Maintenance Record": "Запись о техническом обслуживании",
    "Terms of Service": "Условия обслуживания",
    "Logged in as": "Вошли как",
    "Account Settings": "Настройки аккаунта",
    "Logout": "Выйти",
    "Loading Points List": "Загрузка списка точек",
    "Save": "Сохранить",
    "Cancel": "Отмена",
    "User Name": "Имя пользователя",
    "Email": "Электронная почта",
    "Change password?": "Изменить пароль?",
    "Issue": "Проблема",
    "Equipment": "Оборудование",
    "Equipment Type": "Тип оборудования",
    "Floor": "Этаж",
    "Start Date": "Дата начала",
    "End Date": "Дата окончания",
    "Actions": "Действия",
    "Energy Consumption VS Baseline": "Потребление энергии VS Базовый уровень",
    "Not including all equipment in the building": "Не включая все оборудование в здании",
    "Hour": "Час",
    "Fault severity": "Серьезность неисправности",
    "Fault breakdown": "Разбивка неисправностей",
    "Room Temperature": "Температура в помещении",
    "AHU Run Time (hr)": "Время работы AHU (ч)",
    "Chiller Run Time (hr)": "Время работы чиллера (ч)",
    "User": "Пользователь",
    "test": "тест",
    "Chillers": "Чиллеры",
    "Pumps": "Насосы",
    "VAVs": "VAV (переменный объем воздуха)",
    "AHUs": "AHU (установки обработки воздуха)",
    "Cooling Towers": "Градирни",
    "Baseline": "Базовый уровень",
    "Power (Chiller only) ": "Мощность (только чиллер)",
    "Time": "Время",
    "Power Consumption": "Потребление мощности",
    "Energy Consumption Profile": "Профиль потребления энергии",
    "Time (hourly)": "Время (почасовое)",
    "Energy Consumption Breakdown": "Разбивка потребления энергии",
    "Air conditioning - Air side": "Кондиционирование воздуха - Воздушная сторона",
    "Power Heat Map": "Тепловая карта мощности",
    "Chiller": "Чиллер",
    "Chiller COP": "COP чиллера",
    "AHU": "AHU",
    "Annualized BPI": "Годовой BPI (индекс производительности здания)",
    "Occupant Comfort Index": "Индекс комфорта жильцов",
    "Maintenance Fault Index": "Индекс неисправностей/обслуживания",
    "Energy Saving": "Энергосбережение",
    "Severity": "Серьезность",
    "Topic": "Тема",
    "Download": "Скачать",
    "Alerts": "Оповещения",
    "Recommended Actions": "Рекомендуемые действия",
    "Acknowledged": "Подтверждено",
    "Occured between": "Произошло между",
    "and": "и",
    "Add Maintenance Record": "Добавить запись о техническом обслуживании",
    "View Chart": "Посмотреть график",
    "View Chart in New Tab": "Посмотреть график в новой вкладке",
    "Add maintenance record": "Добавить запись о техническом обслуживании",
    "View chart": "Посмотреть график",
    "View maintenanace records for this period": "Посмотреть записи о техническом обслуживании за этот период",
    "Equipment Health Score": "Оценка состояния оборудования",
    "Export as PDF": "Экспорт в PDF",
    "Create Maintenance Record": "Создать запись о техническом обслуживании",
    "Jump to Equipment Trend Plots": "Перейти к графикам трендов оборудования",
    "Supervised Detection": "Контролируемое обнаружение",
    "Algorithm Detection": "Алгоритмическое обнаружение",
    "Health": "Состояние",
    "Sensor": "Датчик",
    "Supervised Detection Scores (Higher indicates error)": "Оценки контролируемого обнаружения (выше указывает на ошибку)",
    "Anomaly Detection Scores (Higher indicates error)": "Оценки обнаружения аномалий (выше указывает на ошибку)",
    "Unack": "Не подтверждено",
    "Medium": "Средний",
    "High": "Высокий",
    "30 days": "30 дней",
    "90 days": "90 дней",
    "1 year": "1 год",
    "all": "все",
    "Keyword filter": "Фильтр по ключевым словам",
    "Critical/High/Medium": "Критический/Высокий/Средний",
    "Low": "Низкий",
    "Anomaly": "Аномалия",
    "Relevant variables": "Релевантные переменные",
    "Fault Analysis": "Анализ неисправностей",
    "Export all as PDF": "Экспортировать все в PDF",
    "Rule evaluation": "Оценка правила",
    "Change": "Изменить",
    "Analysis": "Анализ",
    "Energy Consumption Comparison Summary": "Сводка сравнения потребления энергии",
    "Outdoor Temperature": "Наружная температура",
    "Fault Severity": "Серьезность неисправности",
    "Chiller Running Hours": "Часы работы чиллера",
    "Fault Breakdown": "Разбивка неисправностей",
    "Weather": "Погода",
    "Baseline Weather": "Базовая погода",
    "Print": "Печать",
    "Energy/Faults": "Энергия/Неисправности",
    "Chiller Plant Performance": "Производительность чиллерной установки",
    "Current": "Текущий",
    "YTD this year": "С начала текущего года",
    "YTD last year": "С начала прошлого года",
    "FDD Costs": "Затраты FDD (диагностика неисправностей)",
    "Unacknowledged": "Не подтверждено",
    "Total": "Всего",
    "Plant COP (chiller only)": "COP установки (только чиллер)",
    "Time ": "Время ",
    "COP": "COP",
    "Chiller COP vs Cooling Load": "COP чиллера vs Холодильная нагрузка",
    "Energy Consumption": "Потребление энергии",
    "Plant COP (chiller only) vs Outdoor Temperature": "COP установки (только чиллер) vs Наружная температура",
    "Header Main Supply Temperature vs Outdoor Temperature": "Температура основной подачи коллектора vs Наружная температура",
    "Outdoor Temp": "Наружная темп.",
    "Header Main Supply Temperature": "Температура основной подачи коллектора",
    "Chilled Water Delta Temp": "Дельта температуры холодной воды",
    "Temperature Diff": "Разница температур",
    "Chiller Plant": "Чиллерная установка",
    "Runtime": "Время работы",
    "Fault": "Неисправность",
    "No fault detected from": "Неисправностей не обнаружено с",
    "to": "по",
    "View anomalies for": "Посмотреть аномалии для",
    "View notifications for": "Посмотреть уведомления для",
    "View equipment summary for": "Посмотреть сводку оборудования для",
    "FDD Faults": "Неисправности FDD",
    "Recommended actions": "Рекомендуемые действия",
    "Most Expensive Faults. Total Cost": "Самые дорогие неисправности. Общая стоимость",
    "Faults With Highest Duration Of Occurrence (hr)": "Неисправности с наибольшей продолжительностью возникновения (ч)",
    "Date From": "Дата с",
    "Date To": "Дата по",
    "Fixed": "Исправлено",
    "Assigned to": "Назначено",
    "Assigned by": "Назначено кем",
    "Assigned date": "Дата назначения",
    "Assigned to me": "Назначено мне",
    "Assigned by me": "Назначено мной",
    "View Points when Chiller is On": "Посмотреть точки, когда чиллер включен",
    "Latest Cooling Load Forecast": "Последний прогноз холодильной нагрузки",
    "Forecast": "Прогноз",
    "Chiller Staging Profile": "Профиль каскадирования чиллера",
    "Export charts as PDF": "Экспортировать графики в PDF",
    "PMV": "PMV (прогнозируемое среднее значение)",
    "View this rule on other equipments in": "Посмотреть это правило на другом оборудовании в",
    "View faults for": "Посмотреть неисправности для",
    "Date Range": "Диапазон дат",
    "Today": "Сегодня",
    "Yesterday": "Вчера",
    "Last 30 Days": "Последние 30 дней",
    "Fault Comparison": "Сравнение неисправностей",
    "Rule": "Правило",
    "No matching equipments": "Нет соответствующего оборудования",
    "No Fault detected for this range and equipment": "Неисправностей не обнаружено для этого диапазона и оборудования",
    "Equipment Name": "Название оборудования",
    "Search": "Поиск",
    "Refresh": "Обновить",
    "Active (hr)": "Активно (ч)",
    "Cost": "Стоимость",
    "Active (as % of on time)": "Активно (в % от времени работы)",
    "Last Detected": "Последнее обнаружение",
    "Issues Diagnostics for": "Диагностика проблем для",
    "Other Readings": "Другие показания",
    "Anomaly Machine Learning Models": "Модели машинного обучения для аномалий",
    "Anomaly machine learning models establish normal operation profile using historical data.": "Модели машинного обучения для аномалий устанавливают профиль нормальной работы, используя исторические данные.",
    "Machine Learning model is data driven and can handle non-linear boundaries and high dimensionality.": "Модель машинного обучения основана на данных и может обрабатывать нелинейные границы и высокую размерность.",
    "Show Mine Only": "Показать только мои",
    "Bulk Upload Excel": "Массовая загрузка Excel",
    "Add Record": "Добавить запись",
    "Notifications": "Уведомления",
    "Show Unack Notifications Only": "Показать только неподтвержденные уведомления",
    "Add Plots": "Добавить графики",
    "Filter": "Фильтр",
    "Drag to Add Lines to Plot": "Перетащите, чтобы добавить линии на график",
    "Password": "Пароль",
    "Login": "Войти",
    "Set Server URL": "Установить URL сервера",
    "Variable X": "Переменная X",
    "Variable Y": "Переменная Y",
    "Facet Groups": "Фасетные группы",
    "Variable Facet": "Фасетная переменная",
    "Chiller Optimisation Example": "Пример оптимизации чиллера",
    "Using PSO optimisation algorithm, expected COP under different operating parameters at particular cooling loads can be found as depicted by the red dots.  The historical consumption is shown as blue dots below.  By choosing optimal temperature setpoints and sequencing, energy saving can be achieved by picking the set of parameters achieving highest COP.": "Используя алгоритм оптимизации PSO, можно найти ожидаемый COP при различных рабочих параметрах и определенных холодильных нагрузках, как показано красными точками. Историческое потребление показано синими точками ниже. Выбирая оптимальные уставки температуры и последовательность, можно достичь экономии энергии, выбрав набор параметров, обеспечивающих наивысший COP.",
    "95% Confidence Interval": "95% доверительный интервал",
    "Actual observed value": "Фактическое наблюдаемое значение",
    "Fitted value": "Подогнанное значение",
    "Expected value": "Ожидаемое значение",
    "Upload File": "Загрузить файл",
    "Remove existing rules": "Удалить существующие правила",
    "Upload": "Загрузить",
    "Upload Excel": "Загрузить Excel",
    "Maintenance Records Creation": "Создание записей о техническом обслуживании",
    "Reference URL": "URL-адрес ссылки",
    "Fixed?": "Исправлено?",
    "Normal maintenance record": "Обычная запись о техническом обслуживании",
    "Comment": "Комментарий",
    "Add": "Добавить",
    "View Reference Link": "Посмотреть ссылку",
    "View Reference Link in New Tab": "Посмотреть ссылку в новой вкладке",
    "Optimization Saving": "Экономия от оптимизации",
    "Digital Twins": "Цифровые двойники",
    "Chiller Efficiency Surface": "Поверхность эффективности чиллера",
    "Optimization Saving Calculation": "Расчет экономии от оптимизации",
    "Optimization is based on temperature reset of the chilled water supply temperature as well as optimal staging of chillers and pumps.": "Оптимизация основана на сбросе температуры подачи холодной воды, а также на оптимальном каскадировании чиллеров и насосов.",
    "Chillers' efficiency would also differ under different loading percentage, environmental conditions and external factors. This provides opportunity to improve the staging of chillers. Further optimization is possible due to unfulfilled temperature reset and differential pressure reset potential. Less cooling capacity buffer would be required if air-side sensors indicates that room temperature is optimal.": "Эффективность чиллеров также будет различаться при разном проценте загрузки, условиях окружающей среды и внешних факторах. Это дает возможность улучшить каскадирование чиллеров. Дальнейшая оптимизация возможна за счет нереализованного потенциала сброса температуры и перепада давления. Меньший буфер холодильной мощности потребуется, если датчики на стороне воздуха указывают на оптимальную температуру в помещении.",
    "Total Cooling Load": "Общая холодильная нагрузка",
    "Duration": "Продолжительность",
    "Projected Energy Consumption": "Прогнозируемое потребление энергии",
    "Saving": "Экономия",
    "Cost Savings": "Экономия затрат",
    "Diagnostic Plots": "Диагностические графики",
    "Power consumption forecast based on setpoint such as evaporator supply temperature and external environment factors such as condenser water temperature and outdoor air temperature.": "Прогноз потребления мощности на основе уставки, такой как температура подачи испарителя, и внешних факторов окружающей среды, таких как температура воды конденсатора и температура наружного воздуха.",
    "The charts reveal the relationship between the prediction and actual consumption.  A chart showing a strong correlation indicates a good model.": "Графики показывают взаимосвязь между прогнозом и фактическим потреблением. График, показывающий сильную корреляцию, указывает на хорошую модель.",
    "Chiller efficiency is greatly influenced by the loading of the chiller and external factor such as condenser water temperature.": "Эффективность чиллера сильно зависит от его загрузки и внешних факторов, таких как температура воды конденсатора.",
    "The 3D scatter plots of the power consumption reveals a efficiency surface where chiller optimization can be performed.": "Трехмерные диаграммы рассеяния потребления мощности показывают поверхность эффективности, на которой можно выполнить оптимизацию чиллера.",
    "Chilled Water Supply Temp (actual)": "Температура подачи холодной воды (фактическая)",
    "Plant COP": "COP установки",
    "Plant Power": "Общая мощность установки",
    "Chilled Water Supply Temp (optimized)": "Температура подачи холодной воды (оптимизированная)",
    "Original COP": "Исходный COP",
    "Optimized COP": "Оптимизированный COP",
    "Original Power": "Исходная мощность",
    "Optimized Power": "Оптимизированная мощность",
    "Menu Configuration": "Конфигурация меню",
    "Air Side Equipment": "Оборудование воздушной стороны",
    "Overall Power Status": "Общее состояние мощности",
    "Condensing Water Pump": "Насос конденсаторной воды",
    "Power Analyzer": "Анализатор мощности",
    "Chilled Water Pump": "Насос холодной воды",
    "Cooling Tower": "Градирня",
    "CHW Header": "Коллектор холодной воды (CHW)",
    "Heatmaps": "Тепловые карты",
    "PAU Breakdown": "Разбивка PAU (приточная установка)",
    "PAU CD_Tem & VFD_Feedback": "Температура подачи PAU и обратная связь VFD",
    "AHU CD_Tem & RT_Tem & VFD_Feedback": "Температура подачи AHU, темп. возврата и обратная связь VFD",
    "AHU CD_Tem & RT_Tem & Valve_Control": "Температура подачи AHU, темп. возврата и управление клапаном",
    "PAU CD_Tem & Valve_Control": "Температура подачи PAU и управление клапаном",
    "AHU RT_Tem vs. VFD_Feedback": "Температура возврата AHU vs Обратная связь VFD",
    "PAU CD_Tem vs. Valve Control": "Температура подачи PAU vs Управление клапаном",
    "AHU CD_Tem vs. Valve Control": "Температура подачи AHU vs Управление клапаном",
    "AHU Breakdown": "Разбивка AHU",
    "AHU CO2": "CO₂ AHU",
    "PAU CO2": "CO₂ PAU",
    "Environmental Performance": "Экологическая эффективность",
    "Running Status - CHWP & WCC": "Рабочее состояние - Насос холодной воды и водо-водяной чиллер",
    "Equipment Power Consumption": "Потребление мощности оборудованием",
    "Running Status - CHWP-A & ACC": "Рабочее состояние - Насос холодной воды-A и воздушно-водяной чиллер",
    "Running Status - WCC & CWP & CT": "Рабочее состояние - Водо-водяной чиллер, насос охлаждающей воды и градирня",
    "Running Status - AHU & PAU": "Рабочее состояние - AHU и PAU",
    "Running Status vs. Schedule": "Рабочее состояние vs. Расписание",
    "CDW Delta T vs Mean CDWP Power": "Дельта T охлаждающей воды vs Средняя мощность насоса охлаждающей воды",
    "WCC Cond Entering & Leaving Temperature": "Температура входа и выхода конденсатора (водо-водяной чиллер)",
    "WCC CHWR_Temp & CHWS_Temp": "Темп. возврата холодной воды и темп. подачи (водо-водяной чиллер)",
    "WCC Cooling Load Overview": "Обзор холодильной нагрузки для водо-водяного чиллера",
    "WCC COP": "COP водо-водяного чиллера",
    "COP vs Cooling Loads ": "COP vs Холодильные нагрузки ",
    "POA Power Factor": "Коэффициент мощности (анализатор мощности)",
    "POA Hz": "Частота (анализатор мощности)",
    "POA Voltage": "Напряжение (анализатор мощности)",
    "POA Power": "Мощность (анализатор мощности)",
    "CHWP VSD_Speed_Feedback": "Обратная связь скорости VSD насоса холодной воды",
    "CT Speed_Feedback": "Обратная связь скорости градирни",
    "CT Wetbulb Approach": "Приближение к температуре мокрого термометра (градирня)",
    "CT Breakdown": "Разбивка градирни",
    "CT Speed Feedback & Running Status": "Обратная связь скорости и рабочее состояние (градирня)",
    "CT Entering & Leaving Temperature": "Температура входа и выхода (градирня)",
    "AHU PAU Temperatures and Setpoints": "Температуры и уставки для AHU и PAU",
    "CHW DP vs OAT": "Перепад давления холодной воды vs Наружная температура",
    "Second Floor Mean Air Temperature": "Средняя температура воздуха второго этажа",
    "First Floor Air Temperature": "Температура воздуха первого этажа",
    "Reset": "Сброс",
    "Upload Point List": "Загрузить список точек",
    "Upload Point List CSV": "Загрузить список точек CSV",
    "Point List upload": "Загрузка списка датчиков",
    "Upload data for": "Загрузить данные для",
    "Upload CSV data for": "Загрузить CSV-файл для",
    "Add Equipment": "Добавить оборудование",
    "Add Point": "Добавить точку",
    "Edit Equipment": "Редактировать оборудование",
    "Delete Equipment": "Удалить оборудование",
    "Upload Data": "Загрузить данные",
    "Edit Point": "Редактировать точку",
    "Delete Point": "Удалить точку",
    "Algorithmic Fault Detection": "Алгоритмическое обнаружение неисправностей",
    "Automated Debug": "Автоматическая отладка",
    "Custom View Configuration Issues": "Проблемы конфигурации пользовательского представления",
    "Chart Builder": "Конструктор графиков",
    "Are you sure you want to delete this item?": "Вы уверены, что хотите удалить этот элемент?",
    "Notes": "Заметки",
    "Sensor Name": "Имя датчика",
    "Sensor Name Abbr": "Сокращенное имя датчика",
    "Faulty": "Неисправный",
    "Upstream ID": "ID вышестоящего элемента",
    "Weight": "Вес",
    "Are you sure you want to delete this sensor?": "Вы уверены, что хотите удалить этот датчик?",
    "Are you sure you want to delete this equipment?": "Вы уверены, что хотите удалить это оборудование?",
    "Add Query": "Добавить запрос",
    "Config ID": "ID конфигурации",
    "Config Name": "Имя конфигурации",
    "Facility Name": "Название объекта",
    "Equipment Tags": "Теги оборудования",
    "Equipment ID": "ID оборудования",
    "Facility ID": "ID объекта",
    "Description": "Описание",
    "Sampling Frequency": "Частота дискретизации",
    "Meta": "Метаданные",
    "ON": "ВКЛ",
    "OFF": "ВЫКЛ",
    "Unit": "Единица измерения",
    "yes": "да",
    "Yes": "Да",
    "no": "нет",
    "No": "Нет",
    "Query": "Запрос",
    "data": "данные",
    "On Only": "Только при включении",
    "Date range offset": "Смещение диапазона дат",
    "Add Time Aggregation": "Добавить агрегацию по времени",
    "Add Aggregation": "Добавить агрегацию",
    "Add Series Calculation": "Добавить расчет ряда",
    "Add Dataframe Transformation": "Добавить преобразование DataFrame",
    "Add Filter": "Добавить фильтр",
    "Add Series Selection": "Добавить выбор ряда",
    "Add Series Insertion": "Добавить вставку ряда",
    "Range offset": "Смещение диапазона",
    "Offset unit": "Единица смещения",
    "Offset amount": "Величина смещения",
    "Time Aggregation": "Агрегация по времени",
    "Frequency": "Частота",
    "Operation": "Операция",
    "Divide by sampling freq": "Разделить на частоту дискретизации",
    "Horizontal Aggregation": "Горизонтальная агрегация",
    "Name": "Имя",
    "Insert Series": "Вставить ряд",
    "Field": "Поле",
    "Value": "Значение",
    "Series Calculation": "Расчет ряда",
    "Remove Others": "Удалить остальные",
    "Formula": "Формула",
    "Dataframe Transformation": "Преобразование DataFrame",
    "Series Selection": "Выбор ряда",
    "Add Series": "Добавить ряд",
    "Please select a Sensor Name or an Equipment Name": "Пожалуйста, выберите имя датчика или имя оборудования",
    "layout": "макет",
    "Chart Type": "Тип графика",
    "Trace Type": "Тип трассировки",
    "Fill": "Заливка",
    "Fill color": "Цвет заливки",
    "Y Axis": "Ось Y",
    "Stack Group": "Группа стека",
    "Render as Smooth Line": "Отображать как сглаженную линию",
    "Min": "Мин",
    "Max": "Макс",
    "Color": "Цвет",
    "Custom Unit": "Пользовательская единица измерения",
    "Opacity": "Непрозрачность",
    "Indicator Mode": "Режим индикатора",
    "Gauge Min": "Индикатор - минимум",
    "Gauge Max": "Индикатор - максимум",
    "Bar color": "Цвет столбца",
    "Border color": "Цвет границы",
    "Background color": "Цвет фона",
    "Bar Mode": "Режим столбцов",
    "Show Scale": "Показать шкалу",
    "Custom Color Gradient": "Пользовательский цветовой градиент",
    "Donut": "Кольцевая диаграмма",
    "Box Points": "Точки ящика с усами",
    "Horizontal": "Горизонтальный",
    "Xbins Size": "Размер интервалов X",
    "Ybins Size": "Размер интервалов Y",
    "Add step": "Добавить шаг",
    "Gauge Steps": "Шаги индикатора",
    "Title": "Заголовок",
    "Chart layout": "Макет графика",
    "Height": "Высота",
    "Top Margin": "Верхний отступ",
    "Left Margin": "Левый отступ",
    "Right Margin": "Правый отступ",
    "Bottom Margin": "Нижний отступ",
    "Hover Tooltip Behaviour": "Поведение всплывающей подсказки при наведении",
    "Show Legend": "Показать легенду",
    "Chart Colors": "Цвета графика",
    "Add Color": "Добавить цвет",
    "Axis settings": "Настройки оси",
    "X Axis Field": "Поле оси X",
    "Independent X Series per Query": "Независимый ряд X для каждого запроса",
    "X Axis Label": "Метка оси X",
    "X Axis Format": "Формат оси X",
    "Y Axis Label": "Метка оси Y",
    "Secondary Y Axis": "Вторичная ось Y",
    "Secondary Y Axis Label": "Метка вторичной оси Y",
    "Color Axis Field": "Поле цветовой оси",
    "Color Axis Scale": "Шкала цветовой оси",
    "Color Axis Label": "Метка цветовой оси",
    "3D Mode Y Axis Field": "Поле оси Y в 3D-режиме",
    "Close": "Закрыть",
    "Compare X": "Сравнить X",
    "Closest to pointer": "Ближайший к указателю",
    "Primary": "Основной",
    "Secondary": "Вторичный",
    "hour": "час",
    "day": "день",
    "week": "неделя",
    "month": "месяц",
    "year": "год",
    "Sensor ID": "ID датчика",
    "Type": "Тип",
    "Connectors": "Коннекторы",
    "Custom View Builder": "Конструктор пользовательских представлений",
    "Edit Custom View": "Редактировать пользовательское представление",
    "Default Date Range": "Диапазон дат по умолчанию",
    "Link Title": "Заголовок ссылки",
    "Column width": "Ширина столбца",
    "Edit": "Редактировать",
    "Duplicate": "Дублировать",
    "Delete": "Удалить",
    "Map": "Карта",
    "Pitch": "Наклон",
    "Zoom": "Масштаб",
    "Center Latitude": "Центральная широта",
    "Center Longitude": "Центральная долгота",
    "Markers": "Маркеры",
    "Image URL": "URL изображения",
    "Link URL": "URL ссылки",
    "Latitude": "Широта",
    "Longitude": "Долгота",
    "Add Marker": "Добавить маркер",
    "OK": "ОК",
    "Width": "Ширина",
    "Radius": "Радиус",
    "Blur": "Размытие",
    "Max opacity": "Макс. непрозрачность",
    "Player": "Плеер",
    "Agg Frequency": "Частота агрегации",
    "Agg Operation": "Операция агрегации",
    "Cutoff Date": "Дата отсечки",
    "Interpolation": "Интерполяция",
    "Min X": "Мин X",
    "Max X": "Макс X",
    "Min Power": "Мин мощность",
    "Max Power": "Макс мощность",
    "Power Sensor": "Датчик мощности",
    "X Sensor": "Датчик X",
    "X Title": "Заголовок X",
    "X Agg Operation": "Операция агрегации X",
    "Switch Sensor": "Датчик переключателя",
    "Use Switch": "Использовать переключатель",
    "Custom Interpolation Function": "Пользовательская функция интерполяции",
    "Min Cooling Load": "Минимальная холодильная нагрузка",
    "Max Cooling Load": "Максимальная холодильная нагрузка",
    "COP Improvement": "Улучшение COP",
    "Cooling Load Sensor": "Датчик холодильной нагрузки",
    "Use Filter": "Использовать фильтр",
    "Filter Sensor": "Датчик фильтра",
    "Min Filter": "Мин фильтр",
    "Max Filter": "Макс фильтр",
    "Correlation": "Корреляция",
    "Relevant Variables": "Релевантные переменные",
    "Rule Active when Equipment On": "Правило активно, когда оборудование включено",
    "Rule Active when Equipment Off": "Правило активно, когда оборудование выключено",
    "Rule Active Anytime": "Правило активно всегда",
    "Show Cost": "Показать стоимость",
    "X Axis Title": "Заголовок оси X",
    "Y Axis Title": "Заголовок оси Y",
    "Expected Value Line Name": "Имя линии ожидаемого значения",
    "Fitted Value Line Name": "Имя линии подогнанного значения",
    "Actual Observed Value Line Name": "Имя линии фактического наблюдаемого значения",
    "Confidence Interval Name": "Имя доверительного интервала",
    "Cooling Load Forecast": "Прогноз холодильной нагрузки",
    "Staging Profile": "Профиль каскадирования",
    "Heatmap": "Тепловая карта",
    "Fault Evaluation": "Оценка неисправности",
    "Chiller Sequencing FLA": "Последовательность чиллера FLA",
    "Chiller Sequencing Delta": "Дельта последовательности чиллера",
    "Cooling Load vs OAT": "Холодильная нагрузка vs Наружная температура",
    "Return to Custom Views": "Вернуться к пользовательским представлениям",
    "Add chart": "Добавить график",
    "Add Chart": "Добавить график",
    "Save as custom view": "Сохранить как пользовательское представление",
    "Add Custom Chart": "Добавить пользовательский график",
    "Pie": "Круговая диаграмма",
    "Bar": "Гистограмма",
    "Histogram": "Гистограмма",
    "Stacked Area": "Область с накоплением",
    "Line": "Линия",
    "Scatter": "Диаграмма рассеяния",
    "3D Scatter": "3D диаграмма рассеяния",
    "Scatter with Color Scale": "Диаграмма рассеяния с цветовой шкалой",
    "Optimization": "Оптимизация",
    "View All": "Посмотреть все",
    "Changes Saved": "Изменения сохранены",
    "Are you sure you want to delete this connector?": "Вы уверены, что хотите удалить этот коннектор?",
    "New Simple View": "Новое простое представление",
    "New Advanced View": "Новое расширенное представление",
    "Import JSON": "Импорт JSON",
    "Import Preset": "Импорт пресета",
    "Import Local Plots": "Импорт локальных графиков",
    "Import custom view from JSON": "Импортировать пользовательское представление из JSON",
    "Import": "Импорт",
    "Publish": "Опубликовать",
    "Un-Publish": "Отменить публикацию",
    "Export": "Экспорт",
    "Facility": "Объект",
    "Published": "Опубликовано",
    "Top-level Link": "Ссылка верхнего уровня",
    "Link position": "Позиция ссылки",
    "Menu Folder": "Папка меню",
    "Are you sure you want to delete this view?": "Вы уверены, что хотите удалить это представление?",
    "View Deleted": "Представление удалено",
    "Custom view saved": "Пользовательское представление сохранено",
    "Are you sure you want to upload all local plots to your user account?": "Вы уверены, что хотите загрузить все локальные графики в свою учетную запись?",
    "Views Imported": "Представления импортированы",
    "A custom view with this ID already exists. Are you sure you want to override it ?": "Пользовательское представление с этим ID уже существует. Вы уверены, что хотите перезаписать его?",
    "End date": "Дата окончания",
    "Dynamic Control": "Динамическое управление",
    "Software Switches": "Программные переключатели",
    "Control Readings": "Показания управления",
    "Sensor Readings": "Показания датчика",
    "Point Name": "Имя точки",
    "Status": "Статус",
    "Error": "Ошибка",
    "Equipment plots": "Графики оборудования",
    "Equipment name": "Название оборудования",
    "Start date": "Дата начала",
    "Floor name": "Название этажа",
    "Equipment Summary": "Сводка оборудования",
    "Display equipment plots": "Отобразить графики оборудования",
    "Display anomalies": "Отобразить аномалии",
    "Data Export": "Экспорт данных",
    "View Data": "Посмотреть данные",
    "Download CSV": "Скачать CSV",
    "Time Agg Frequency": "Частота агрегации по времени",
    "Time Agg Operation": "Операция агрегации по времени",
    "Return data as": "Вернуть данные как",
    "Series name": "Имя ряда",
    "Change Password": "Изменить пароль",
    "User ID": "ID пользователя",
    "Update On": "Обновлено",
    "Created On": "Создано",
    "Role": "Роль",
    "Users": "Пользователи",
    "Dashboard Setup": "Настройка панели управления",
    "Not logged in as administrator": "Не вошли как администратор",
    "Log Out": "Выйти",
    "Dashboard setup complete": "Настройка панели управления завершена",
    "Back to Home": "Вернуться на главную",
    "Current Logged In User": "Текущий вошедший пользователь",
    "Facility and Points": "Объект и точки",
    "Current Facility": "Текущий объект",
    "Equipment List and Points": "Список оборудования и точки",
    "used": "использовано",
    "licensed": "лицензировано",
    "Setting": "Настройка",
    "sample": "образец",
    "samples": "образцы",
    "every hour": "каждый час",
    "Currency and Energy Pricing": "Валюта и цены на энергию",
    "per kWh": "за кВтч",
    "Points List": "Список точек",
    "Energy Price": "Цена на энергию",
    "Equipment On": "Оборудование включено",
    "Equipment Off": "Оборудование выключено",
    "Anytime": "В любое время",
    "Active": "Активно",
    "Inactive": "Неактивно",
    "Muted": "Заглушено",
    "Applicable Group(s)": "Применимые группы",
    "Rule Active when": "Правило активно, когда",
    "Active Status": "Активный статус",
    "Reports": "Отчеты",
    "Test Message": "Тестовое сообщение",
    "Severity Level(s)": "Уровни серьезности",
    "Distribution List": "Список рассылки",
    "Power Prediction": "Прогноз мощности",
    "Parameter Name": "Имя параметра",
    "Parameter Value": "Значение параметра",
    "Parameter Value Str": "Значение параметра (текст)",
    "Parameter Description": "Описание параметра",
    "Graphical View": "Графическое представление",
    "Model": "Модель",
    "Add Model": "Добавить модель",
    "Model Name": "Имя модели",
    "Model Type": "Тип модели",
    "Job": "Задание",
    "Add Job": "Добавить задание",
    "New Job": "Новое задание",
    "No Result Yet": "Результатов пока нет",
    "Reset all result": "Сбросить все результаты",
    "Reset all result will delete all result and rerun with latest setting.": "Сброс всех результатов удалит все данные и перезапустит процесс с последними настройками.",
    "Train Comp Power Model": "Обучить модель мощности компрессора",
    "This will retrain the Comp Power Model": "Это переобучит модель мощности компрессора",
    "Ack Old Notifications": "Подтвердить старые уведомления",
    "Ack Old Notifications older than the following threshold or 30 days if no threshold is mentioned.": "Подтвердить уведомления старше следующего порога или 30 дней, если порог не указан.",
    "End date threshold": "Порог даты окончания",
    "Job ID": "ID задания",
    "Carnot Innovations Terms of Service": "Условия обслуживания Carnot Innovations",
    "Critical": "Критический",
    "Download with Maintenance": "Скачать (включая обслуживание)",
    "Severity filter": "Фильтр серьезности",
    "Notification ID": "ID уведомления",
    "Occurred Times": "Количество возникновений",
    "Focus Range": "Диапазон фокуса",
    "Location": "Местоположение",
    "Start Time": "Время начала",
    "End Time": "Время окончания",
    "Comments": "Комментарии",
    "Actions Taken": "Предпринятые действия",
    "Reported by": "Сообщено",
    "Report date": "Дата отчета",
    "Certified by": "Сертифицировано",
    "Certified date": "Дата сертификации",
    "Endorsed by": "Одобрено",
    "Endorsed date": "Дата одобрения",
    "Menu List": "Список меню",
    "New Folder Name": "Новое имя папки",
    "Available Views": "Доступные представления",
    "Edit Folder Name": "Редактировать имя папки",
    "Edit Custom View Display": "Редактировать отображение пользовательского представления",
    "Custom View Name": "Имя пользовательского представления",
    "Icon": "Иконка",
    "Folder cannot be nested!": "Папка не может быть вложенной!",
    "Folder name must be unique.": "Имя папки должно быть уникальным.",
    "Add Anomaly Description": "Добавить описание аномалии",
    "Relevant variable": "Релевантная переменная",
    "Equipment Regex": "Регулярное выражение для оборудования",
    "Time Delay": "Задержка времени",
    "Open diagnostics view": "Открыть представление диагностики",
    "timestamp": "метка времени",
    "Top 10 overall anomaly scores": "Топ-10 общих оценок аномалий",
    "File must be selected.": "Файл должен быть выбран.",
    "Exactly 1 file must be provided.": "Необходимо предоставить ровно 1 файл.",
    "Done": "Готово",
    "Please select 1 file to upload.": "Пожалуйста, выберите 1 файл для загрузки.",
    "Please wait ... It will take up to a minute.": "Пожалуйста, подождите... Это может занять до минуты.",
    "Upload Completed.": "Загрузка завершена.",
    "Fail.  Please Retry.": "Ошибка. Пожалуйста, повторите попытку.",
    "Add Tag": "Добавить тег",
    "Connector": "Коннектор",
    "Add Points": "Добавить точки",
    "Point Selector": "Селектор точек",
    "Available points": "Доступные точки",
    "Show filters": "Показать фильтры",
    "Hide filters": "Скрыть фильтры",
    "Selected points": "Выбранные точки",
    "Clear selection": "Очистить выбор",
    "Add selected points": "Добавить выбранные точки",
    "Total energy consumption (kWh)": "Общее потребление энергии (кВтч)",
    "Energy Savings": "Энергосбережение",
    "Add Dates": "Добавить даты",
    "Add Equipment Servicing Schedule": "Добавить график обслуживания оборудования",
    "Applies to": "Применяется к",
    "Entire Site": "Весь объект",
    "Floor Name": "Название этажа",
    "View": "Вид",
    "Apply changes": "Применить изменения",
    "Save whiteboard": "Сохранить доску",
    "Edit all notes": "Редактировать все заметки",
    "Add Stickie to board": "Добавить стикер на доску",
    "Add Photo / Graphics to board": "Добавить фото/графику на доску",
    "Add Board": "Добавить доску",
    "Board Name": "Название доски",
    "Double Click to select an image.": "Дважды щелкните, чтобы выбрать изображение.",
    "Edit this Stickie": "Редактировать этот стикер",
    "Delete this Stickie": "Удалить этот стикер",
    "Edit Image": "Редактировать изображение",
    "Edit Label": "Редактировать метку",
    "Label": "Метка",
    "Label Only": "Только метка",
    "Font size": "Размер шрифта",
    "Font color": "Цвет шрифта",
    "Variable": "Переменная",
    "Microsoft authentication anomaly. Please renew login.": "Аномалия аутентификации Microsoft. Пожалуйста, обновите вход.",
    "Change Backend URL": "Изменить URL бэкенда",
    "Target URL": "Целевой URL",
    "Setting URL.  Please wait.": "Установка URL. Пожалуйста, подождите.",
    "Set": "Установить",
    "Model ID": "ID модели",
    "Target Equipment": "Целевое оборудование",
    "Model Selection": "Выбор модели",
    "Model Message": "Сообщение модели",
    "Training Data Date Range": "Диапазон дат обучающих данных",
    "Severity Levels": "Уровни серьезности",
    "Phone number": "Номер телефона",
    "Message": "Сообщение",
    "Send": "Отправить",
    "Active - rule will be applied": "Активно - правило будет применено",
    "Inactive - rule will not run": "Неактивно - правило не будет выполняться",
    "Muted - rules will be applied, but notifications (if any) will immediately be acknowledged": "Заглушено - правила будут применены, но уведомления (если есть) будут немедленно подтверждены",
    "Used parameters": "Используемые параметры",
    "Recommended Action": "Рекомендуемое действие",
    "Run test": "Запустить тест",
    "Test the rule": "Тестировать правило",
    "Validation succeeded!": "Проверка прошла успешно!",
    "Password not matched / Password cannot be empty": "Пароль не совпадает / Пароль не может быть пустым",
    "Confirm New Password": "Подтвердите новый пароль",
    "New Password": "Новый пароль",
    "Administrator": "Администратор",
    "Maintainer": "Обслуживающий персонал",
    "Operator": "Оператор",
    "Updated On": "Обновлено",
    "Authorized Facilities": "Авторизованные объекты",
    "User Account": "Учетная запись пользователя",
    "Monthly Summary Energy/Faults": "Ежемесячная сводка Энергия/Неисправности",
    "Monthly Summary: Chiller Plant": "Ежемесячная сводка: Чиллерная установка",
    "Chiller Staging": "Каскадирование чиллера",
    "Edit Maintenance Record": "Редактировать запись о техническом обслуживании",
    "Builder": "Конструктор",
    "Equipment Group": "Группа оборудования",
    "FDD Breakdown": "Разбивка FDD",
    "Cluster View": "Кластерное представление",
    "Get link": "Получить ссылку",
    "Chiller Plant Overview": "Обзор чиллерной установки",
    "General - CHW_Header Leaving and Entering Temp": "Общее - Темп. выхода и входа коллектора холодной воды (CHW)",
    "General - CHW_Header DP vs OAT": "Общее - Перепад давления коллектора холодной воды (CHW) vs Наружная температура",
    "Advanced - Cooling Load and Power Over Time": "Расширенное - Холодильная нагрузка и мощность со временем",
    "Advanced - CHW_Header Depth Analysis": "Расширенное - Глубокий анализ коллектора холодной воды (CHW)",
    "Cooling Load Prediction": "Прогноз холодильной нагрузки",
    "Last 10 Days Cooling Load Prediction": "Прогноз холодильной нагрузки за последние 10 дней",
    "Hide Date": "Скрыть дату",
    "Monthly": "Ежемесячно",
    "Month Range": "Диапазон месяцев",
    "On Only Switch": "Переключатель 'Только при включении'",
    "Equip Select": "Выбор оборудования",
    "Equipment Type filter": "Фильтр по типу оборудования",
    "Equipment Floor filter": "Фильтр по этажу оборудования",
    "Min Width": "Мин ширина",
    "Borders": "Границы",
    "Restricted Access": "Ограниченный доступ",
    "Namespace": "Пространство имен",
    "Hide Controls": "Скрыть элементы управления",
    "Menu Config": "Конфигурация меню",
    "Save As": "Сохранить как",
    "Add Component": "Добавить компонент",
    "Rich Text": "Форматированный текст",
    "Notification Facet": "Фасет уведомлений",
    "3D Viewer": "3D-просмотрщик",
    "3D Heatmap": "3D-тепловая карта",
    "Custom Optimization": "Пользовательская оптимизация",
    "Custom COP Savings": "Пользовательская экономия COP",
    "Custom": "Пользовательский",
    "HTML Code": "HTML-код",
    "Custom EC": "Пользовательский EC",
    "Animation": "Анимация",
    "Enable Merge": "Включить объединение",
    "Animation timer (seconds)": "Таймер анимации (секунды)",
    "Maintenance Summary": "Сводка по техническому обслуживанию",
    "Issue Summary": "Сводка проблем",
    "Grahic": "Графика",
    "FDD Report": "Отчет FDD",
    "Cost Breakdown": "Разбивка затрат",
    "Sensor Cailbration": "Калибровка датчика",
    "Energy Breakdown": "Разбивка энергии",
    "Solar": "Солнечная энергия",
    "Main light intensity": "Интенсивность основного света",
    "Ambient light intensity": "Интенсивность окружающего света",
    "Show Clock": "Показать часы",
    "Parameters": "Параметры",
    "Autotuner": "Автонастройщик",
    "Actual Observed Value": "Фактическое наблюдаемое значение",
    "Fitted Value": "Подогнанное значение",
    "Expected Value": "Ожидаемое значение",
    "Insert at": "Вставить в",
    "Air-side": "Воздушная сторона",
    "Air-side Overview": "Обзор воздушной стороны",
    "Air-side CO2 Overtime": "CO₂ воздушной стороны со временем",
    "AHU Temp and VFD Over Time": "Температура AHU и VFD со временем",
    "Download plot as a png": "Скачать график как png",
    "Zoom in": "Увеличить",
    "Zoom out": "Уменьшить",
    "Autoscale": "Автомасштаб",
    "Reset axes": "Сбросить оси",
    "Pan": "Панорамирование",
    "Toggle Spike Lines": "Переключить линии-указатели",
    "Show closest data on hover": "Показывать ближайшие данные при наведении",
    "Compare data on hover": "Сравнивать данные при наведении",
    "Produced with Plotly": "Создано с помощью Plotly",
    "Rows per page": "Строк на странице",
    "Maintenance ID": "ID обслуживания",
    "View points when equipment is On": "Посмотреть точки, когда оборудование включено",
    "Reassign user for all maintenance records": "Переназначить пользователя для всех записей обслуживания",
    "Mass Reassign": "Массовое переназначение",
    "Currently assigned to": "В настоящее время назначено",
    "Reassign to": "Переназначить",
    "Reassign": "Переназначить",
    "View Diff": "Посмотреть разницу",
    "Diff mode": "Режим сравнения",
    "Select file": "Выбрать файл",
    "Choose File": "Выберите файл",
    "Convert categorical to numeric": "Преобразовать категориальные в числовые",
    "Resampling": "Передискретизация",
    "Matching": "Сопоставление",
    "Data Upload": "Загрузка данных",
    "Toggle Connectors": "Переключить коннекторы",
    "Graphic": "Графика",
    "Equipment Relationships": "Связи оборудования",
    "Equipment1": "Оборудование1",
    "Equipment2": "Оборудование2",
    "Graph view": "Графическое представление",
    "List view": "Представление списком",
    "Relationships type": "Тип связей",
    "Equipment Relationships Upload": "Загрузка связей оборудования",
    "Point Mapping": "Сопоставление точек",
    "Point Mapper": "Маппер точек",
    "Mass Update": "Массовое обновление",
    "Split Paths": "Разделить пути",
    "Map Points": "Сопоставить точки",
    "Get Suggestions": "Получить предложения",
    "Suggestions": "Предложения",
    "Units": "Единицы измерения",
    "Delete Table": "Удалить таблицу",
    "id": "id",
    "path": "путь",
    "carnot_name": "имя_carnot",
    "point": "точка",
    "equip": "оборудование",
    "equip_type": "тип_оборудования",
    "floor": "этаж",
    "tower": "башня",
    "unit": "единица",
    "actions": "действия",
    "No data available": "Нет доступных данных",
    "Discovered Points": "Обнаруженные точки",
    "upstream_id": "id_вышестоящего",
    "upstream_sensor_name": "имя_вышестоящего_датчика",
    "site": "объект",
    "sensor_name": "имя_датчика",
    "sensor_desc": "описание_датчика",
    "meta": "метаданные",
    "equip_meta": "метаданные_оборудования",
    "Unmapped Only": "Только несопоставленные",
    "Scripts": "Скрипты",
    "Script": "Скрипт",
    "Version": "Версия",
    "Updated": "Обновлено",
    "Optimization Controls": "Элементы управления оптимизацией",
    "Current Value": "Текущее значение",
    "Write": "Записать",
    "Priority": "Приоритет",
    "Graphics": "Графика",
    "Dashboard": "Панель управления",
    "Build time": "Время сборки",
    "Coordinated Universal Time": "Всемирное координированное время",
    "Rule Creation": "Создание правила",
    "Auto-diagnose": "Автодиагностика",
    "This will disable all rules which lack the required variables. Are you sure you want to run auto-diagnostic?": "Это отключит все правила, для которых отсутствуют необходимые переменные. Вы уверены, что хотите запустить автодиагностику?",
    "KPI Thresholds": "Пороги КПЭ",
    "Custom view": "Пользовательское представление",
    "New Link Name": "Новое имя ссылки",
    "Show Recent Notifications Only": "Показывать только недавние уведомления",
    "Apply": "Применить",
    "3D Model link": "Ссылка на 3D-модель",
    "Close testing interface": "Закрыть интерфейс тестирования",
    "Component Titles": "Заголовки компонентов",
    "Last Updated": "Последнее обновление",
    "Add components": "Добавить компоненты",
    "Toggle sensor picker": "Переключить выбор датчика",
    "Toggle debug mode": "Переключить режим отладки",
    "Time aggregation": "Агрегация по времени",
    "Latest Only": "Только последние",
    "Custom date range": "Пользовательский диапазон дат",
    "Presents": "Презентации",
    "Summary": "Сводка",
    "Bar - group": "Столбцы - группа",
    "Bar - stack": "Столбцы - стек",
    "Bar summary": "Сводка в столбцах",
    "Gauge": "Индикатор",
    "Number": "Число",
    "Layout": "Макет",
    "Legend Position": "Положение легенды",
    "Colors": "Цвета",
    "Limit X Axis Ticks": "Ограничить деления оси X",
    "Y Axis Format": "Формат оси Y",
    "Y Axis Custom Range": "Пользовательский диапазон оси Y",
    "Marker Size Field": "Поле размера маркера",
    "Color Axis Custom Range": "Пользовательский диапазон цветовой оси",
    "Annotations": "Аннотации",
    "Text": "Текст",
    "Returned series": "Возвращенные ряды",
    "Add Series Insertion by Ref": "Добавить вставку ряда по ссылке",
    "Add Calendar Insertion": "Добавить вставку календаря",
    "Add Conversion to enum": "Добавить преобразование в перечисление",
    "Number Size": "Размер числа",
    "Number Format": "Формат числа",
}
